import type { CalendarEventWhisper as CalendarEventWhisperData } from '@frontend/api-types';
import { formatDateTimeRange } from '@frontend/duck-tape';
import { YStack } from '@frontend/web-react';
import { CalendarEventDetailRow } from './CalendarEventDetailRow';

export type CalendarEventWhisperProps = {
  whisper: CalendarEventWhisperData;
};

export const CalendarEventWhisper = ({ whisper }: CalendarEventWhisperProps) => {
  const attendeesLine = whisper.attendees?.length ? whisper.attendees.join(' · ') : undefined;
  return (
    <YStack className="gap-xxs">
      <CalendarEventDetailRow iconName="IconClock" text={formatDateTimeRange(whisper.startsAt, whisper.endsAt)} />
      {whisper.location ? <CalendarEventDetailRow iconName="IconMapPin" text={whisper.location} /> : null}
      {attendeesLine ? <CalendarEventDetailRow iconName="IconUsers" text={attendeesLine} /> : null}
    </YStack>
  );
};
